module.exports = __webpack_public_path__ + "img/童仲彥.d742e472.png";